import { render, staticRenderFns } from "./WhyGarryWalkerRealEstate.vue?vue&type=template&id=f85aa5be&scoped=true&"
import script from "./WhyGarryWalkerRealEstate.vue?vue&type=script&lang=ts&"
export * from "./WhyGarryWalkerRealEstate.vue?vue&type=script&lang=ts&"
import style0 from "./WhyGarryWalkerRealEstate.vue?vue&type=style&index=0&id=f85aa5be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85aa5be",
  null
  
)

export default component.exports